import Box, { BoxProps } from '@mui/material/Box';

import { NAV } from '../config-layout';

export default function Main({ children, sx, ...other }: BoxProps) {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        width: `calc(100vw - ${NAV.W_VERTICAL})`,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
